import { Box, MetricComponent } from 'components'
import { ColorType } from 'constants/colors'
import { BigNumber } from 'ethers'
import { formatBigNumber } from 'utils'
import { CoreCapsuleWithAccount } from '../../../entities'

export interface IBorrowUsageProps {
  coreCapsule: CoreCapsuleWithAccount
  futureLTV: BigNumber | null
  isAtRisk: boolean
  isExitTransaction: boolean
}

export const LTVUsage = ({
  coreCapsule,
  futureLTV,
  isAtRisk,
  isExitTransaction,
}: IBorrowUsageProps) => {
  const {
    accountProperties: { currentLTV, maxLTV },
  } = coreCapsule

  let futureValue = '0.00%'
  let futureColor: ColorType = 'GREEN_5'

  if (!isExitTransaction) {
    futureValue = futureLTV ? `${formatBigNumber(futureLTV.mul(100), 2)}%` : null
    futureColor = isAtRisk ? 'RED_5' : 'GREEN_5'
  }

  return (
    <>
      <Box
        flexDirection="row"
        alignItems="flex-start"
        justifyContent="space-between"
        style={{ position: 'relative' }}
      >
        <Box flexGrow={1} flexBasis={0}>
          <MetricComponent
            title="Current LTV"
            value={`${formatBigNumber(currentLTV.mul(100), 2)}%`}
            futureValue={futureValue}
            futureValueColor={futureColor}
            tooltip="Total value of your debt position divided by the total value of your collateral."
            labelSize={'xs'}
          />
        </Box>
        <Box
          width="1px"
          backgroundColor="TEXT_DARK"
          style={{ opacity: 0.5, position: 'absolute', top: 0, bottom: 0, left: '50%' }}
        />
        <Box flexGrow={1} flexBasis={0}>
          <MetricComponent
            title="Max LTV"
            value={`${formatBigNumber(maxLTV.mul(100), 2)}%`}
            tooltip="Maximum allowed Loan-To-Value ratio on this vault. Grows with credit score."
            alignItems="flex-end"
            labelSize={'xs'}
          />
        </Box>
      </Box>
    </>
  )
}
